import {
	Component,
	Inject,
	OnInit,
	ChangeDetectionStrategy
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
	selector: "core-error-conflict",
	styleUrls: ["./style.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "error-conflict.html"
})
export class CoreErrorDialogComponent implements OnInit {
	messages: string[] = [];
	constructor(
		public dialogRef: MatDialogRef<CoreErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: HttpErrorResponse
	) {
		let msg =
			"Ticket is already updated by someone else. Try to close and open ticket again.";
		this.messages.push(msg);
	}

	ngOnInit(): void {}

	onClose() {
		this.dialogRef.close(false);
	}

	onCloseReload() {
		this.dialogRef.close(true);
	}
}
